import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/views/configurator/_components/hero-section/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/views/configurator/_components/request-section/personalization-list/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/views/configurator/_components/request-section/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/nesterenko/src/views/configurator/_components/request-section/request-form/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/views/configurator/index.module.scss");
